<template>
  <div>
    <b-modal hide-footer centered v-model="visible">
      <template #modal-title> Change Massage </template>

      <b-form-group
        label-for="status"
        class="w-100 pt-1"
        label="Change the current Massage"
      >
        <b-form-textarea
          id="textarea"
          v-model="nameMessage"
          placeholder="Enter something..."
          rows="2"
          class="overflow-hidden"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button @click="changeMessages" class="gradient-btn">
          change
        </b-button>
      </div>
      <loader :loading="loading" />
    </b-modal>
  </div>
</template>

<script>
import { BModal, BFormGroup, BButton, BFormTextarea } from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BFormTextarea,
    Loader,
  },
  props: {
    currentData: {
      status: Object,
      default: () => {},
    },
    showChangeMessage: {
      status: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      textErea:''
    };
  },
  computed: {
    nameMessage: {
      get() {
              return this.currentData.name;

      },
      set(val) {
         this.textErea = val;
      },
    },
    visible: {
      get() {
        return this.showChangeMessage;
      },
      set(val) {
        this.$emit("close", val);
      },
    },
  },

  methods: {
    async changeMessages() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(`/panel/messages/${this.currentData.id}`, {
          _method:'patch', 
          name:{
            en:this.textErea
          },
        });
        this.visible = false;
        this.$emit("updatePartners");
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.btn {
  background-color: #252531;
  border: 1px solid #ffffff0d;
}
@media (min-width: 576px) {
  .modal-dialog {
    width: 560px !important;
  }
}
</style>
